import axios from "axios";
import { getPublicURL, getAPIUrl } from "./configs/global_var";
import { history } from "./history";

const setAPI = async () => {
  const newAPI = await getAPIUrl();

  const instance = axios.create({
    baseURL: newAPI[0].api + "api_colagio/",
    // baseURL: "https://colagio.shratech.com/api_colagio",
  });

  instance.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
      return config;
    } else {
      if (config.data === undefined) {
        // console.log(config);
        return config;
      } else {
        config.headers["x-access-token"] = config.data.token;
        return config;
      }
    }
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log(error.response);
      if (error.message === "Network Error") {
        return Promise.reject(error);
      } else if (error.response.status === 401) {
        setTimeout(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenInst");
          localStorage.clear();
          history.push("/");
          window.location.reload();
          // history.push("/pages/login");
        }, 2000);
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    }
  );

  return instance;
};

export default setAPI;
